import React from 'react';
import { getCategoryTheme, isValidHexColor } from '../AbsenceCalendar/Utils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

type Props = {
  icon: string | null;
  color?: string | null;
  className?: string;
  tooltip?: React.ReactNode;
};

const Icon: React.FC<
  React.PropsWithChildren<Pick<Props, 'icon' | 'color' | 'className'>>
> = ({ icon, color, className }) => {
  const { icon: categoryIcon, iconColor } = getCategoryTheme(icon, color);

  return (
    <i
      className={['fe', categoryIcon, className].join(' ')}
      style={isValidHexColor(color) ? { color: iconColor } : undefined}
    />
  );
};

const AbsenceCategoryIcon: React.FC<React.PropsWithChildren<Props>> = ({
  icon,
  color,
  className,
  tooltip,
}) =>
  tooltip ? (
    <OverlayTrigger
      overlay={
        <Tooltip id={`absence-category-icon-${icon}`}>{tooltip}</Tooltip>
      }>
      <span className={className}>
        <Icon icon={icon} color={color} />
      </span>
    </OverlayTrigger>
  ) : (
    <Icon icon={icon} color={color} className={className} />
  );

export default AbsenceCategoryIcon;
